<template>
  <div class="economy-calc">
    <ParamsForm ref="form" :form="params" :default-params="defaultParams" @submit="handleSubmit" />

    <div class="continue-calculations" :class="{ 'continue-calculations--hide': hideButton }">
      <button class="continue-calculations__btn" @click="scrollToBtn">
        Продолжить расчеты
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.5 7L8 11L12.5 7" stroke="white" stroke-width="2" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import ParamsForm from './ParamsForm.vue';
import scrollTo from '~scripts/core/scrollTo';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

export default {
  name: 'EconomyCalculator',
  components: {
    ParamsForm,
  },
  props: {
    defaultParams: {
      type: Object,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hideButton: true,
      loading: false,
    };
  },
  computed: {
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaMd() {
      return window.matchMedia(`(max-width: ${this.breakpoints.mdMax})`);
    },
  },
  mounted() {
    this.toggleScrollBtn();
    this.mediaMd.addEventListener('change', this.handleMediaChange);
    this.handleMediaChange(this.mediaMd);
  },
  methods: {
    initScrollListener() {
      window.addEventListener('scroll', this.toggleScrollBtn);
    },
    removeScrollListener() {
      window.removeEventListener('scroll', this.toggleScrollBtn);
    },
    toggleScrollBtn() {
      this.hideButton = !(window.scrollY === 0);
    },
    scrollToBtn() {
      const footer = document.querySelector('.footer');
      const rect = footer.getBoundingClientRect();
      scrollTo(rect.top + window.scrollY - window.innerHeight, { duration: 500 });
    },
    perYear(n, shouldFormat = false) {
      const result = Math.ceil(n * 12);
      if (shouldFormat) {
        return numFormat.format(result);
      }
      return result;
    },
    handleMediaChange(event) {
      this.isDesktop = !event.matches;
      if (this.isDesktop) {
        this.toggleScrollBtn();
      }
      this.isDesktop ? this.initScrollListener() : this.removeScrollListener();
      this.hideButton = !this.isDesktop;
    },
    handleSubmit() {
      const queryParams = new URLSearchParams({
        amount: this.params.amount,
        salary: this.params.salary,
        resume_per_day: this.params.params.resume_per_day,
        mail_tpl_per_day: this.params.params.mail_tpl_per_day,
        cal_per_day: this.params.params.cal_per_day,
        mail_per_day: this.params.params.mail_per_day,
      });

      this.removeScrollListener();
      scrollTo(0, { duration: 300 });

      localStorage.setItem('params', JSON.stringify(this.params));
      document.querySelector('.calc').classList.add('fade-down');

      setTimeout(() => {
        window.location.href = `/calc/result?${queryParams.toString()}`;
      }, 300);
    },
  },
};
</script>

<style lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;
@use '~styles/components/texts' as texts;

.economy-calc {
  @include mixins.media(lg) {
    padding-left: 4rem;
  }

  @include mixins.media(xl) {
    padding-left: 5rem;
  }
}

.continue-calculations {
  position: fixed;
  right: 0;
  bottom: 0;
  padding: 2.4rem 7rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 10;
  width: calc(50% + 120px);
  background-color: #fff;
  transition: 0.2s;

  @media (min-height: 1370px) {
    display: none;
  }

  &--hide {
    transform: translateY(100%);
  }

  &__btn {
    @include mixins.font(1.6rem, 1.25);

    display: inline-flex;
    align-items: center;
    border-radius: 32px;
    background-color: #6f67e6;
    padding: 6px 16px;
    color: #fff;
    cursor: pointer;

    svg {
      margin-left: 4px;
    }
  }
}
</style>
